'use strict';

(function() {
	angular.module('onboarding.common')
		.directive('cobNavigation', cobNavigation);

	cobNavigation.$inject = [
		'$timeout', 'observerService', 'subjectObserverMessagesService', 'authenticationService', 'sessionService',
		'$state', '$stateParams'
	];

	var $timeout,
		observerService,
		subjectObserverMessagesService,
		authenticationService,
		observerMessages,
		sessionService,
		$state,
		$stateParams;

	function cobNavigation(_$timeout_,
		_observerService_,
		_subjectObserverMessagesService_,
		_authenticationService_,
		_sessionService_,
		_$state_,
		_$stateParams_) {
		$timeout = _$timeout_;
		observerService = _observerService_;
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		authenticationService = _authenticationService_;
		sessionService = _sessionService_;
		$state = _$state_;
		$stateParams = _$stateParams_;

		return {
			restrict: 'E',
			scope: {},
			replace: true,
			templateUrl: '/app/common/directives/navigation.html',
			link: linkFunction
		};
	}

	// There will be only 1 instance of this directive on the page
	function linkFunction(scope) {
		scope.m = {
			tabs: {
				carriers: 'carriers',
				contracts: 'contracts',
				carriersAdmin: 'carriersAdmin',
				brokersAdmin: 'brokersAdmin',
				contractsAdmin: 'contractsAdmin'
			}
		};
		scope.isCarrier = sessionService.isCarrier;
		scope.isAuthorizedCarrierRead = sessionService.isAuthorizedCarrierRead;
		scope.isInternalAdmin = isInternalAdmin;
		scope.getBrokerImpersonated = getBrokerImpersonated;
		scope.isMasquerading = isMasquerading;
		scope.isAuthorizedBroker = isAuthorizedBroker;
		scope.isAuthorizedCarrier = isAuthorizedCarrier;

		scope.$state = $state;
		scope.$stateParams = $stateParams;

		activate();

		function activate() {
			observerMessages = subjectObserverMessagesService.getObserverMessages();
			registerObserverHandlers();
		}

		function registerObserverHandlers() {
			observerService.registerHandlers(scope,
				[
					{ message: observerMessages.COB_OBSERVER_LOGIN_FINISHED_SUCCESS, handler: onSetup },
					{ message: observerMessages.COB_OBSERVER_SESSION_RESUME, handler: onSetup }
				]);
		}

		function getBrokerImpersonated() {
			return sessionService.getBrokerImpersonated();
		}

		function isMasquerading() {
			return $stateParams.brokerId ||
                $stateParams.carrierId;
		}

		function onSetup(data) {
			scope.userName = data.userName;
			scope.capabilities = data.capabilities;
		}

		function isInternalAdmin() {
			return sessionService.isAuthorizedInternalAdmin();
		}

		function isAuthorizedBroker() {
			return sessionService.isAuthorizedBrokerRead();
		}

		function isAuthorizedCarrier() {
			return sessionService.isAuthorizedCarrierRead();
		}

	}
})();
